import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { IconChevronRight } from '@tabler/icons-react';

export interface ActionCardProps {
  /** Big icon on the left (24 to 28 px Tabler icon). */
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  /** Navigate here (renders a link) ... */
  to?: string;
  /** ... or run this (renders a button). */
  onClick?: () => void;
  /** Greyed out with a dashed border; `description` should say why. */
  disabled?: boolean;
  /** Teal border: the main choice on the screen. */
  primary?: boolean;
}

/**
 * A large card that takes the member somewhere ("I need a ride", "Offer a lift"). Always shows a
 * chevron so it reads as tappable. For choosing between options inside a step, use PickerCard.
 */
export function ActionCard({ icon, title, description, to, onClick, disabled, primary }: ActionCardProps) {
  const inner = (
    <>
      {icon && <span className="glyph" aria-hidden="true">{icon}</span>}
      <span className="txt">
        <span className="t">{title}</span>
        {description && <span className="d">{description}</span>}
      </span>
      {!disabled && <span className="chev" aria-hidden="true"><IconChevronRight size={24} /></span>}
    </>
  );
  const cls = `rides-actioncard${primary ? ' primary' : ''}`;
  if (to && !disabled) return <Link to={to} className={cls}>{inner}</Link>;
  return (
    <button type="button" className={cls} onClick={disabled ? undefined : onClick} aria-disabled={disabled || undefined}>
      {inner}
    </button>
  );
}
